import type { CreateConfigValues } from "@paperclipai/adapter-utils";

export const defaultCreateValues: CreateConfigValues = {
  adapterType: "claude_local",
  cwd: "",
  instructionsFilePath: "",
  promptTemplate: "",
  model: "",
  thinkingEffort: "",
  chrome: false,
  dangerouslySkipPermissions: true,
  search: false,
  fastMode: false,
  dangerouslyBypassSandbox: false,
  command: "",
  args: "",
  extraArgs: "",
  envVars: "",
  envBindings: {},
  url: "",
  bootstrapPrompt: "",
  payloadTemplateJson: "",
  workspaceStrategyType: "project_primary",
  workspaceBaseRef: "",
  workspaceBranchTemplate: "",
  worktreeParentDir: "",
  runtimeServicesJson: "",
  maxTurnsPerRun: 1000,
  heartbeatEnabled: false,
  intervalSec: 300,
  // openclaw_gateway defaults
  authToken: "",
  agentId: "",
  sessionKeyStrategy: "issue",
  sessionKey: "",
  timeoutSec: undefined,
  waitTimeoutMs: undefined,
  disableDeviceAuth: undefined,
  autoPairOnFirstConnect: undefined,
  devicePrivateKeyPem: "",
  role: "",
  scopes: "",
  paperclipApiUrl: "",
  headersJson: "",
  password: "",
};
